import type { FitViewOptions, Viewport } from "@xyflow/react";

export const DAG_AUTO_FIT_OPTIONS: FitViewOptions = {
  padding: 0.15,
  duration: 400,
  maxZoom: 1,
};

export function clampDagViewport(viewport: Viewport): Viewport {
  return {
    x: Math.round(viewport.x),
    y: Math.round(viewport.y),
    zoom: viewport.zoom,
  };
}
